import produce from "immer";
import { CustomizationState } from "../../";

export interface SetDisplayPreviewAction {
  opened: boolean;
  type: "setDisplayPreview";
}

export function setDisplayPreview(
  state: CustomizationState,
  action: SetDisplayPreviewAction
): CustomizationState {
  return produce(state, (draftState) => {
    draftState.ui.previewOpened = action.opened;
  });
}
